/* Retired promotional variants: removal only. Never allocates free items. */
(function () {
 'use strict';
 if (window.__lvRetiredPromotions) return;
 window.__lvRetiredPromotions = true;
 var ids = new Set([62849916993695,62849917026463,62849917059231,62849917091999,62849917124767,62849917157535,62849917190303,62849917223071,62857887842463,62857891152031]);
 var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
 var originalFetch = window.fetch.bind(window), pending = null, timer;
 function isRetired(item) { return ids.has(Number(item.variant_id || item.id)); }
 function check(response) { if (!response.ok) throw new Error('Unable to update cart'); return response.json(); }
 function purge() {
  if (pending) return pending;
  pending = originalFetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(check).then(function(cart){
   var updates = {};
   (cart.items || []).filter(isRetired).forEach(function(item){updates[item.key]=0;});
   if (!Object.keys(updates).length) return cart;
   return originalFetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})}).then(check).then(function(updated){
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:updated}}));
    document.querySelectorAll('[data-variant-id]').forEach(function(el){if(ids.has(Number(el.dataset.variantId)))el.remove();});
    // Refresh existing cart sections using Shopify's native section rendering.
    if (location.pathname.replace(/\/$/,'').endsWith('/cart')) location.reload();
    return updated;
   });
  }).finally(function(){pending=null;});
  return pending;
 }
 function schedule(){clearTimeout(timer);timer=setTimeout(function(){purge().catch(function(){/* Checkout rechecks before proceeding. */});},100);}
 // Observe successful cart mutations without changing request or response data.
 window.fetch=function(input,options){
  var url=typeof input==='string'?input:(input && input.url)||'';
  return originalFetch(input,options).then(function(response){if(response.ok && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url))schedule();return response;});
 };
 document.addEventListener('cart:updated',schedule);
 var bypass=false;
 function checkout(target){return target && target.closest('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]');}
 document.addEventListener('click',function(event){
  var button=checkout(event.target);
  if(!button || bypass || event.defaultPrevented)return;
  event.preventDefault();event.stopImmediatePropagation();
  purge().then(function(){bypass=true;try{button.click();}finally{bypass=false;}}).catch(function(){window.alert('We could not refresh your cart. Please try again.');});
 },true);
 document.addEventListener('submit',function(event){
  if(bypass || !event.submitter || event.submitter.name!=='checkout')return;
  event.preventDefault();event.stopImmediatePropagation();
  var form=event.target,submitter=event.submitter;
  purge().then(function(){bypass=true;try{form.requestSubmit(submitter);}finally{bypass=false;}}).catch(function(){window.alert('We could not refresh your cart. Please try again.');});
 },true);
 schedule();
})();
